import { GoogleGenerativeAI } from "@google/generative-ai";
import axios from "axios";
import env from "react-dotenv";

let conversationHistory = "";

export const generateText = async (prompt: string, API_KEY : string) => {
  try {

    const genAI = new GoogleGenerativeAI(API_KEY);
    const model = genAI.getGenerativeModel({ model: "gemini-1.5-flash" });

    // Inclure l'historique des conversations dans le prompt
    const fullPrompt = `${conversationHistory}\nUser: ${prompt}\nAI:`;

    const result = await model.generateContent(fullPrompt);

    const generatedText = result.response.text().toString();

    // Mettre à jour l'historique des conversations
    conversationHistory += `\nUser: ${prompt}\nAI: ${generatedText}`;

    return generatedText; // Retourner les résultats
  } catch (error) {
    // console.error("Erreur lors de la génération du texte:", error);
    throw error;
  }
};
